import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import ServiceSwiper from '../service-swiper'
import ServicePart1 from './serviceHomePart1'
import ServicePart2 from './serviceHomePart2'
import ServicePart3 from './serviceHomePart3'
import ServicePart4 from './serviceHomePart4'
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';
import EzBottom from '../bottom';

interface ServiceHomeProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (type: 'basic' | 'premium') => void;
    onOpenNote?: (type: 'basic' | 'premium') => void;
}

const ServiceHome: React.FC<ServiceHomeProps> = ({ handleViewChange, onOpenModal, onOpenNote }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { getValue } = useCustomData();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    const serviceHomeTitle = getValue('serviceHomeTitle');
    const serviceHomeSubTitle = getValue('serviceHomeSubTitle');
    const serviceHomeMainTitle = getValue('serviceHomeMainTitle');
    const serviceHomeMainSubTitle = getValue('serviceHomeMainSubTitle');
    const serviceHomePart3H1 = getValue('serviceHomePart3H1');
    const serviceHomePart3H2 = getValue('serviceHomePart3H2');
    const serviceHomePart3H3 = getValue('serviceHomePart3H3');
    const serviceHomePart3H4 = getValue('serviceHomePart3H4');
    const knowMore = getValue('knowMore');

    useEffect(() => {}, []);

    return (
        <div className='service-home'>
            <ServiceSwiper />
            <div className='service-h1'>{serviceHomeTitle}</div>
            <ServicePart1 handleViewChange={handleViewChange} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />
            <div className='service-h1' style={{ marginBottom: '24px' }}>{serviceHomeSubTitle}</div>
            <div className="service-tab-h2" style={{ color: themeColor, marginBottom: '16px' }}>
                <div>{serviceHomeMainTitle}</div>
            </div>
            <div className="service-tab-h3">
                <div>{serviceHomeMainSubTitle}</div>
            </div>
            <ServicePart2 handleViewChange={handleViewChange} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />

            <div className='service-div-button'>
                <button
                    onClick={() => { handleViewChange("service-index") }}
                    style={{ background: themeColor, boxShadow: `0 2px 4px 0` + themeColor }}
                    className='service-button'
                >
                    {knowMore}
                </button>
            </div>

            <div className="service-tab-h2" style={{ color: themeColor, marginBottom: '16px' }}>
                <div>{serviceHomeMainTitle}</div>
            </div>

            {/* ✅ 用 img 方式写，不用 css */}
            <div style={{ width: '1200px', margin: '0 auto' }}>
                <img
                    src={require(`../../assets/image/serviceTab-${languageCode}.png`)}
                    alt="service-tab"
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                />
            </div>

            <div className='service-home-part3'>
                <div className='service-home-part3-inner'>
                    <div className="service-part3-h1">{serviceHomePart3H1}</div>
                    <div className="service-part3-h2">{serviceHomePart3H2}</div>
                    <div className="service-part3-h3">{serviceHomePart3H3}</div>
                    <ServicePart3 handleViewChange={handleViewChange} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />
                </div>
            </div>

            <div className='service-home-part4'>
                <div className='service-home-part4-inner'>
                    <div className="service-part4-h1">{serviceHomePart3H4}</div>
                    <ServicePart4 handleViewChange={handleViewChange} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />
                </div>
            </div>

            <EzBottom />
        </div>
    )
};

export default ServiceHome;
